import { render, staticRenderFns } from "./IconCompletedFilledSingleColor.vue?vue&type=template&id=ea2f4efc&scoped=true"
import script from "./IconCompletedFilledSingleColor.vue?vue&type=script&lang=js"
export * from "./IconCompletedFilledSingleColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2f4efc",
  null
  
)

export default component.exports